export enum LobbyIcon {
  ANTE = 'ante',
  BOMB_POT = 'bomb-pot',
  CAP = 'cap',
  DEEP_STACK = 'deep-stack',
  DOUBLE_BOARD = 'double-board',
  HYPER = 'hyper',
  TURBO = 'turbo',
  JACKPOT = 'jackpot',
  KILL_GAME = 'kill-game',
  REAL_NAME = 'real-name',
  RUN_IT_TWICE = 'run-it-twice',
  SPIN_UP = 'spin-up',
  SQUID_GAME = 'squid-game',
  STRADDLE = 'straddle',
  // OFC-specific icons
  OFC_PINEAPPLE = 'ofc-pineapple',
  JOKERS = 'jokers',
  PROGRESSIVE = 'progressive',
  TWO_SEVEN = 'two-seven',
}

export const LOBBY_ICONS = Object.values(LobbyIcon);

export const LOBBY_ICON_LABELS = {
  [LobbyIcon.ANTE]: 'Ante',
  [LobbyIcon.BOMB_POT]: 'Bomb Pot',
  [LobbyIcon.CAP]: 'Capped',
  [LobbyIcon.DEEP_STACK]: 'Deep Stack',
  [LobbyIcon.DOUBLE_BOARD]: 'Double Board',
  [LobbyIcon.HYPER]: 'Hyper',
  [LobbyIcon.TURBO]: 'Turbo',
  [LobbyIcon.JACKPOT]: 'Jackpot',
  [LobbyIcon.KILL_GAME]: 'Kill Game',
  [LobbyIcon.REAL_NAME]: 'Real Names',
  [LobbyIcon.RUN_IT_TWICE]: 'Run It Twice',
  [LobbyIcon.SPIN_UP]: 'Spin Up',
  [LobbyIcon.SQUID_GAME]: 'Squid Game',
  [LobbyIcon.STRADDLE]: 'Straddle',
  // OFC-specific icons
  [LobbyIcon.OFC_PINEAPPLE]: 'Pineapple',
  [LobbyIcon.JOKERS]: 'Jokers',
  [LobbyIcon.PROGRESSIVE]: 'Progressive',
  [LobbyIcon.TWO_SEVEN]: '2-7',
} as const;
